import { AccountController } from "@repo/baseCloud";
import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../../api/queries";

export function useAuthSettings(username?: string) {
	return useQuery({
		queryFn: () => AccountController.getSettings(username),
		queryKey: [QUERY_KEYS.Login.AuthSettings, username],
	});
}

export function useMfaTypes(username: string) {
	return useQuery({
		queryFn: () => AccountController.getMfaTypes(username),
		queryKey: [QUERY_KEYS.Login.MfaTypes, username],
		enabled: !!username,
	});
}
